import { cn } from '@/platform/lib/utils';
import { TabPanel as HeadlessTabPanel } from '@headlessui/react';

const TabPanel = ({ className, children, ...props }) => (
    <HeadlessTabPanel
        className={cn('data-focus:outline-hidden', className)}
        {...props}
    >
        {children}
    </HeadlessTabPanel>
);

export default TabPanel;
